export const PROFILES = {
    vendedorSoma: 1,
    vendedorFranquia: 2,
    vendedorCorporativo: 3,
    vendedorMultimarca: 4,
    vendedorLojaVirtualAnimale: 5,
    lojaSoma: 6,
    lojaMultimarca: 7,
    supervisao: 8,
    planejamento: 9,
    diretor: 10,
    lojaFranquia: 11,
    treinadorAdoroCodigo: 12,
    treinadorLojaVirtualAnimale: 13,
    vendedorAdoroCodigo: 14,
    caixaSoma: 15,
    caixaMultimarca: 16,
    estoquistaSoma: 17,
    subgerenteSoma: 18,
    influenciadoresOff: 19,
    influenciadoresOffVendedores: 20,
};

export const BRANDS = {
    animale: 1,
    off: 6,
    foxton: 7,
    mariaFilo: 15,
};

export const COMMISSION_FREEZE_PERIOD = {
    startDay: 20,
    endDay: 26,
};

export const isWithinQuotaFreezePeriod = (currentDay, { startDay, endDay }) => {
    if (startDay < endDay) {
        return currentDay > startDay && currentDay < endDay;
    }
    return currentDay > startDay || currentDay < endDay;
};

export const BRANCHES = {
    MF_oscarFreire: '000313',
    MF_parkBrasilia: '000315',
    MF_plazaNiteroi: '000293',
};
